import { HttpResponse } from 'msw';

import { FILES_LIST, DEVICE_TYPE, getPartNumber } from '../constants';

type LegacyBody = { command?: string; access?: string };

export function handleSystemLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (command) {
    case 'files':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      return HttpResponse.json(
        {
          spacefree: 10485760,
          files: FILES_LIST,
          webexport: false,
        },
        { status: 200 },
      );

    case 'dnsclient':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      return HttpResponse.json(
        {
          enabled: true,
          server_primary: '8.8.8.8',
          server_secondary: '8.8.4.4',
          domain_name: 'local',
          dns_query_timeout: 5,
          dns_query_retries: 3,
          dns_over_tcp: false,
        },
        { status: 200 },
      );

    case 'set info':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: 'system:set info requires access set',
        },
        { status: 400 },
      );

    case 'get time':
      if (access === 'get') {
        return HttpResponse.json(
          { time: new Date().toISOString() },
          { status: 200 },
        );
      }
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: 'system:get time requires access get',
        },
        { status: 400 },
      );

    case 'get id':
      return HttpResponse.json(
        {
          sn: 'ROQ123456789',
          'sw version': '1.0.0',
          'mgmt mac': '00:11:22:33:44:55',
          'part number': getPartNumber(),
          poe: DEVICE_TYPE.includes('4GE'),
          'cfg number': '001',
        },
        { status: 200 },
      );
    case 'get uptime':
      return HttpResponse.json({ uptime: '00:00:00' }, { status: 200 });
    case 'get info':
      return HttpResponse.json(
        {
          name: 'ROQSTAR',
          description: 'Managed Ethernet Switch',
          location: 'Data Center A',
          contact: 'support@example.invalid',
        },
        { status: 200 },
      );
    case 'get supply':
      return HttpResponse.json({ v1: true, v2: false }, { status: 200 });
    case 'devicenumbers':
      return HttpResponse.json({ 'cfg number': '001' }, { status: 200 });
    case 'get config name':
      return HttpResponse.json({ cfgName: 'default.cfg' }, { status: 200 });
    case 'has unsaved changes':
      return HttpResponse.json({ changes: false }, { status: 200 });
    case 'save config with name':
      return HttpResponse.json(
        { success: true, message: 'Configuration saved' },
        { status: 200 },
      );
    case 'factory reset':
      return HttpResponse.json({ ok: true }, { status: 200 });
    case 'create config':
      return HttpResponse.json(
        { ok: true, config: { mock: true } },
        { status: 200 },
      );
    case 'get id open api':
      return HttpResponse.json(
        {
          description: 'ROQSTAR Managed Switch (mock)',
          'part number': '006-130-140',
          sn: 'RQS-00001234',
          'mgmt mac': 'AA:BB:CC:DD:EE:FF',
          'sw version': '1.2.3-mock',
          configname: 'Switch-1.cfg',
        },
        { status: 200 },
      );
    case 'slots':
      return HttpResponse.json(
        {
          booted: 'system0',
          system0: '1.2.3-mock',
          system1: '1.2.2-mock',
        },
        { status: 200 },
      );
    case 'install update':
    case 'reboot':
    case 'boot alternative partition':
      return HttpResponse.json({ ok: true }, { status: 200 });

    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for system:${command}`,
        },
        { status: 400 },
      );
  }
}
